export default "__VITE_ASSET__Dyu4uLSR__"